export default __webpack_public_path__ + "static/media/logo.4bb537a8.png";